<template>
  <audio ref="audioRef" controls autoplay hidden>
    <source src="@/assets/sounds/s08.mp3" type="audio/mpeg" />
  </audio>
</template>
<script>
export default {
  name: "Audio",
  data() {
    return {};
  },
  computed: {
    timer() {
      return this.$store.getters["app/timer"];
    },
    isNotice() {
      return this.$store.getters["app/isNotice"];
    },
  },
  watch: {
    timer(val) {
      if (val === 1) {
        this.playAudio();
      }
    },
    isNotice(val) {
      if (val) {
        this.$store.dispatch("app/countdown");
      }
    },
  },
  methods: {
    playAudio() {
      if (this.$refs.audioRef) {
        this.$refs.audioRef.play();
      }
    },
  },
  mounted() {
    // 啟動倒數計時
    this.$store.dispatch("app/countdown");
    this.$emit("mounted", this.$refs.audioRef);
  },

  beforeDestroy() {
    // 組件銷毀時停止計時器
    this.$store.dispatch("app/stopCountdown");
  },
};
</script>
<style lang="scss" scoped></style>
